import React from 'react';

const CSS = `
  .gong-tip { display: flex; align-items: flex-start; gap: 10px; background: rgba(255,255,255,0.03); border: 1px solid rgba(240,236,224,0.1); border-radius: 2px; padding: 8px 12px; margin-bottom: 10px; animation: fadeUp 0.45s 0.25s ease both; }
  .gong-tip.warm { border-left: 3px solid #ffaa44; }
  .gong-tip.cold { border-left: 3px solid #7eb8d4; }
  .gong-tip-icon { font-size: 16px; flex-shrink: 0; margin-top: 2px; }
  .gong-tip-label { font-family: 'DM Mono', monospace; font-size: 9px; letter-spacing: 0.18em; color: rgba(240,236,224,0.3); text-transform: uppercase; margin-bottom: 3px; }
  .gong-tip-text { font-family: 'Josefin Sans', sans-serif; font-size: 13px; color: rgba(240,236,224,0.6); line-height: 1.55; letter-spacing: 0.03em; }
`;

function getTip(w) {
  const kmh = w.windSpeed * 3.6;
  const rainy = ['Rain','Drizzle','Snow'].includes(w.condition);
  if (rainy || w.rainProbability >= 60) return { icon: '☂️', warm: false, text: "Rain is likely. Set up a canopy before you start — you'll be glad you did." };
  if (kmh >= 30) return { icon: '💨', warm: false, text: 'Strong winds today. Keep the lid closed — wind strips heat fast.' };
  if (kmh >= 15) return { icon: '🌬️', warm: true, text: 'Moderate wind. Point the vent into the wind for better airflow.' };
  if (w.temperature <= 8) return { icon: '🥶', warm: false, text: "Cold out. Gas grill recommended — charcoal struggles below 10°C." };
  if (w.humidity >= 80) return { icon: '💧', warm: true, text: 'High humidity. Charcoal may take longer to catch — give it extra time.' };
  if (w.temperature >= 32) return { icon: '🌡️', warm: true, text: "Hot day. Don't leave raw meat out — food safety matters more in the heat." };
  if (w.condition === 'Clear' && kmh <= 12) return { icon: '🔥', warm: true, text: 'Near-perfect conditions. Great day for a low-and-slow cook.' };
  return { icon: '👌', warm: true, text: 'Decent conditions. Nothing to worry about — enjoy the grill.' };
}

export default function BBQTip({ weatherData }) {
  if (!weatherData) return null;
  const tip = getTip(weatherData);
  return (
    <>
      <style>{CSS}</style>
      <div className={`gong-tip ${tip.warm ? 'warm' : 'cold'}`}>
        <span className="gong-tip-icon">{tip.icon}</span>
        <div>
          <div className="gong-tip-label">Grill Tip</div>
          <div className="gong-tip-text">{tip.text}</div>
        </div>
      </div>
    </>
  );
}
